module.exports = __webpack_public_path__ + "static/media/maria2.4cb9c26d.mp3";